// extracted by mini-css-extract-plugin
export default {"section":"section--z5JU_","title":"title--O_Nmb","content":"content--yIzPm"};